import { KSelectRangeDate, KSpan } from "kahuna-base-react-components"
import { useState } from "react"
import { lang } from "../../../constants/languages"
import ArtistOverview from "./artist-overview/ArtistOverview"
import PlatformPerformance from "./platform-performance/PlatformPerformance"
import TrackPerformance from "./track-performance/TrackPerformance"
import AudienceAndDiscovery from "./audience-and-discovery/AudienceAndDiscovery"
import Trends from "../trends/Trends"
import { DateRangeType } from "kahuna-base-react-components/dist/components/KSelectRange/KSelectRange"
import { ANALYSIS_TAB_OPTIONS, defaultEndDate, defaultStartDate } from "../../../constants"
import { formatDate, toYYYYMMDD } from "../../../utility"

const Analysis = () => {
  const [selectedTab, setSelectedTab] = useState(ANALYSIS_TAB_OPTIONS.ARTIST_OVERVIEW)
  const [dateValues, setDateValues] = useState<DateRangeType>([defaultStartDate, defaultEndDate])
  const renderTabs = () => {
    return (
      <div className="w-full flex flex-row items-center justify-between gap-3 flex-wrap-reverse">
        <div className="flex gap-4 ml-3">
          {Object.values(ANALYSIS_TAB_OPTIONS).map((option) => {
            return (
              <div
                key={`${option}`}
                className="cursor-pointer"
                onClick={() => {
                  setSelectedTab(option)
                }}
                style={{ borderBottom: selectedTab === option ? "1px solid #666666" : "" }}
              >
                <KSpan
                  text={lang.analytics[option].tab_title}
                  fontWeight={selectedTab === option ? 500 : 400}
                  color={selectedTab === option ? "#111111" : ""}
                />
              </div>
            )
          })}
        </div>
        <div className="flex flex-row items-center gap-3">
          <KSpan
            text={`${formatDate(toYYYYMMDD((dateValues as Date[])[0]))} - ${formatDate(
              toYYYYMMDD((dateValues as Date[])[1])
            )}`}
            color="#111"
            fontWeight={500}
          />
          <KSelectRangeDate
            value={dateValues}
            onChange={(dateRange) => {
              setDateValues(dateRange)
            }}
            height="36px"
            width="36px"
            backgroundColor="#F7F7F7"
            hoverBackgroundColor="#F3F3F3"
            boxShadow="none"
            weeklyMode={true}
          />
        </div>
      </div>
    )
  }
  return (
    <div className="flex flex-col gap-2 p-2 mt-7">
      <div className="w-full flex items-center">{renderTabs()}</div>
      {selectedTab === ANALYSIS_TAB_OPTIONS.ARTIST_OVERVIEW && <ArtistOverview dateValues = {dateValues}/>}
      {selectedTab === ANALYSIS_TAB_OPTIONS.PLATFORM_PERFORMANCE && <PlatformPerformance dateValues = {dateValues}/>}
      {selectedTab === ANALYSIS_TAB_OPTIONS.TRACK_PERFORMANCE && <TrackPerformance dateValues = {dateValues}/>}
      {selectedTab === ANALYSIS_TAB_OPTIONS.AUDIENCE && <AudienceAndDiscovery dateValues = {dateValues}/>}
      {(selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_DAILY ||
        selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_COUNTRY ||
        selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_DEMOGRAPHIC) && (
        <Trends isAdmin={false} externalTab={selectedTab} hideSideBarAndTitle={true} commonDateValues={dateValues}/>
      )}
    </div>
  )
}

export default Analysis
